import { useEffect } from 'react';
export default function useIntervals(callback, timeouts) {
    useEffect(() => {
        const allTimeouts = [];
        for (const timeout of timeouts) {
            allTimeouts.push(setInterval(callback, timeout));
        }
        return () => {
            try {
                for (const interval of allTimeouts) {
                    clearInterval(interval);
                }
            }
            catch (error) {
                console.log(error);
            }
        };
    }, [timeouts, callback]);
}
